import React from "react";

const PayConfBar  = () => {
    return(
        <div className="conf-bar">
            <ul className="conf-bar__row">
                <li className="text-jost-sb-22 completed">Add Courses</li>
                <li className="text-jost-sb-22 active ">Payment DETAILS</li>
                <li className="text-jost-sb-22 ">ConfirmationS</li>

            </ul>
        </div>
    );
};
export default PayConfBar;